'use client';

import { Icon, Text, useTranslation } from '@weareconceptstudio/core';
import FulfillmentChipsStyle from './style';
import { useFulfillmentChips } from './useFulfillmentChips';

const FulfillmentChips = ({
	compact = false,
	iconOnly = false,
	allowOnHomePage = false,
	promptOnShopEnter = false,
}) => {
	const { translate } = useTranslation();
	const {
		isVisible,
		wrapperClassName,
		isTakeaway,
		hasFulfillmentSelection,
		iconOnly: isIconOnly,
		locationLabel,
		timeLabel,
		openDeliveryPopup,
	} = useFulfillmentChips({ compact, iconOnly, allowOnHomePage, promptOnShopEnter });

	if (!isVisible) return null;

	const showLocationChip = !compact && hasFulfillmentSelection && locationLabel;

	return (
		<FulfillmentChipsStyle
			className={[wrapperClassName, !showLocationChip ? 'is-single-chip' : ''].filter(Boolean).join(' ')}>
			<button
				type='button'
				className='fulfillment-type-btn'
				onClick={openDeliveryPopup}
				aria-label={translate('fulfillmentChips.openDeliveryOptions')}>
				{isIconOnly ? (
					<Icon
						name='location'
						className='fulfillment-mobile-icon'
					/>
				) : (
					<>
						<Text
							className='p p4 font-montserrat-arm-regular fulfillment-type-label'
							text={isTakeaway ? 'deliveryTemplate.takeawayTab' : 'deliveryTemplate.deliveryTab'}
						/>
						<Icon
							name='right-arrow'
							className='fulfillment-chevron icon-desktop arrow-right'
						/>
					</>
				)}
			</button>

			{showLocationChip && (
				<button
					type='button'
					className='fulfillment-location-chip'
					onClick={openDeliveryPopup}
					aria-label={translate('fulfillmentChips.openDeliveryOptions')}>
					<Icon
						name='location'
						className='fulfillment-pin icon-desktop'
					/>
					<Text className='text font-montserrat-arm-regular fulfillment-chip-location'>{locationLabel}</Text>
					{timeLabel && (
						<span
							className='fulfillment-chip-separator'
							aria-hidden
						/>
					)}
					{timeLabel && (
						<Text className='text font-montserrat-arm-regular fulfillment-chip-time'>{timeLabel}</Text>
					)}
				</button>
			)}
		</FulfillmentChipsStyle>
	);
};

export default FulfillmentChips;
